import React from 'react';
import { Icon } from '../Icon/Icon';
import styles from './DividerWithLogo.module.scss';

const DividerWithLogo = () => (
  <div className="level is-mobile">
    <div className="level-item">
      <hr className={styles.fullWidth} />
    </div>
    <div className={`level-item has-text-centered ${styles.IconContainer}`}>
      <Icon name="ck-logo" size="large" color="primary" />
    </div>
    <div className="level-item">
      <hr className={styles.fullWidth} />
    </div>
  </div>
);

export { DividerWithLogo };
